/**
 * Calendar Preferences API Service
 * Handles all calendar preferences-related API calls to the backend
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

/**
 * Fetch current user's calendar preferences
 */
export const fetchCalendarPreferences = async () => {
    const response = await fetch(
        `${API_BASE_URL}/v1/users/me/calendar-preferences`,
        {
            credentials: 'include'
        }
    );
    
    if (!response.ok) {
        throw new Error(`Failed to fetch calendar preferences: ${response.statusText}`);
    }
    
    return await response.json();
};

/**
 * Update current user's calendar preferences
 */
export const updateCalendarPreferences = async (preferencesData) => {
    const response = await fetch(
        `${API_BASE_URL}/v1/users/me/calendar-preferences`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(preferencesData)
        }
    );
    
    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.detail || `Failed to update calendar preferences: ${response.statusText}`);
    }
    
    return await response.json();
};

